"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var includes = require('lodash/includes');

var noop = require('lodash/noop');

var backoff = require('./back-off');
/**
 * Wrap the request function with a retry handler. Executes the callback with
 * original api response if the success code is in the 2xx range. Executes
 * callback function with a status of `0` if the backoff function gives up.
 *
 * @param  {function} func         The `anonymous` or `authenticated` request
 *                                 function from the `request` module.
 * @param  {object} retryOptions See the `backoff` module + below
 * @param  {array}  retryOptions.haltOnStatus List of status codes on which to stop future attempts
 */


function withRetry(func) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var retryOptions = _objectSpread({
    haltOnStatus: []
  }, opts);

  var backoffOpts = {
    attemptCount: 1
  }; // Assists with mocking API calls with nock in tests

  if (process.env.NODE_ENV === 'test') {
    backoffOpts.delay = 5;
    backoffOpts.maxDelay = 500;
  }

  var next = backoff.async(_objectSpread(_objectSpread({}, backoffOpts), opts));
  return function (options) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var makeRequest = function makeRequest() {
      func(options, function (status, response) {
        if (includes(retryOptions.haltOnStatus, status)) {
          callback(status, response);
          return;
        }

        if (status >= 200 && status < 300) {
          callback(status, response);
        } else if (!next(function () {
          return makeRequest();
        })) {
          callback(status, response);
        }
      });
    };

    makeRequest(options, callback);
  };
}

module.exports = withRetry;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/request/lib/with-retry.js
// module id = 330
// module chunks = 0 1